import src from "IMAGE";
export default { src, width: 400, height: 72, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AEFBQTVOTk4/XV1dTGRkZE5ubm5VTExMO2JiYk8wMDAmpkQJ6P//P5MAAAAASUVORK5CYII="};
